import { NetworkPointResource } from 'app/_resources/network-point.resource';
import * as angular from 'angular';

class NetworkPointBundleSituationComponentCtrl implements ng.IController {
    public gridNode: NetworkPointDto;
    public gridNodeId: number;
    public gridNodeBundled: boolean;
    public loggedInTsoRefId: number;

    public loadingFinished: boolean;
    public errorMessage: string;
    public bundle: BundleDto;
    public relatedGridNodes: NetworkPointSimpleDto[];
    public headIdentifier: string;

    constructor(private NetworkPoint: NetworkPointResource) {}

    $onInit() {
        if (this.gridNode != null) {
            this.gridNodeId = this.gridNode.id;
            this.gridNodeBundled = this.gridNode.bundled;
        }

        if (this.gridNodeBundled) {
            this.NetworkPoint.findBundleSituationForBundlePoint(
                { refId: this.gridNodeId },
                (res: BundleDto) => {
                    this.bundle = res;
                    this.relatedGridNodes = res.bundlingSituation;

                    if (this.relatedGridNodes) {
                        this.setHeadIdentifier(res.bundlingSituation);
                    }
                    this.loadingFinished = true;
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'Failed to load additional network point information';
                    this.loadingFinished = true;
                }
            );
        } else {
            this.NetworkPoint.findRelatedBundlesForNetworkPoint(
                { refId: this.gridNodeId },
                (res: NetworkPointSimpleDto[]) => {
                    this.relatedGridNodes = res;
                    this.loadingFinished = true;
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'Failed to load additional network point information';
                    this.loadingFinished = true;
                }
            );
        }
    }

    private setHeadIdentifier(relatedGridNodes: NetworkPointSimpleDto[]) {
        const entries: NetworkPointSimpleDto[] = relatedGridNodes.filter(
            (networkPoint) => networkPoint.direction === 'ENTRY'
        );
        if (entries.length > 1) {
            this.headIdentifier = relatedGridNodes.find(
                (networkPoint) => networkPoint.direction === 'EXIT'
            ).identifier;
        } else {
            this.headIdentifier = entries.pop().identifier;
        }
    }
}

angular.module('app').component('pkpNetworkPointBundleSituation', {
    controller: NetworkPointBundleSituationComponentCtrl,
    template:
        require('app/network-point/network-point-bundle-situation.component.html'),
    bindings: {
        loadingFinished: '=',
        gridNode: '<',
        gridNodeId: '<',
        gridNodeBundled: '<',
        loggedInTsoRefId: '<'
    }
});
